import React, { useState, useRef, useEffect } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { format } from "date-fns";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

const DateRangeSelector = ({
  style,
  onDateRangeChange,
  trip,
  fromChild = null,
}) => {
  const initialState = [
    { startDate: null, endDate: new Date(null), key: "selection" },
  ];

  const isValidFromChild = fromChild?.[0]?.startDate;
  const valueFromParent = isValidFromChild
    ? [
        {
          startDate: new Date(fromChild[0].startDate),
          endDate: new Date(fromChild[0].endDate),
          key: "selection",
        },
      ]
    : initialState;
  const [state, setState] = useState(valueFromParent);
  const [openCalendar, setOpenCalendar] = useState(false);
  const [calendarDirection, setCalendarDirection] = useState("horizontal");
  const calendarRef = useRef(null);
  const hasStartDateRef = useRef(false);
  const prevEndDateRef = useRef(state[0].endDate);
  const handleSelect = (item) => {
    const newSelection = item.selection;
    const currentStartDate = newSelection.startDate;
    const currentEndDate = newSelection.endDate;
    const prevEndDate = prevEndDateRef.current;
    if (!hasStartDateRef.current && currentEndDate) {
      hasStartDateRef.current = true;
    }
    setState([newSelection]);
    if (
      hasStartDateRef.current &&
      currentStartDate &&
      currentEndDate &&
      !(currentStartDate.getTime() === currentEndDate.getTime())
    ) {
      setOpenCalendar(false);
      if (onDateRangeChange) {
        onDateRangeChange([
          {
            startDate: new Date(Date.parse(currentStartDate)),
            endDate: new Date(Date.parse(currentEndDate)),
            key: "selection",
          },
        ]);
      }
    }

    prevEndDateRef.current = currentEndDate;
  };

  const handleClickOutside = (event) => {
    if (calendarRef.current && !calendarRef.current.contains(event.target)) {
      setOpenCalendar(false);
    }
  };

  const updateDirection = () => {
    setCalendarDirection(window.innerWidth <= 768 ? "vertical" : "horizontal");
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("resize", updateDirection);
    updateDirection();

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("resize", updateDirection);
    };
  }, []);

  return (
    <div style={{ position: "relative" }}>
      <div
        className={`d-flex align-items-center ${
          openCalendar ? "calender-active" : "calender-cont"
        }`}
        style={{ gap: 20 }}
      >
        {["Start-trip", "End-trip"].map((label, index) => (
          <div
            key={index}
            onClick={() => setOpenCalendar(true)}
            className="rdtextcont d-flex align-items-center ahc-gap"
            style={{ gap: 20 }}
          >
            <CalendarTodayIcon />
            <div>
              <p
                className="fs-8 fw-500"
                style={{ color: "var(--label-text-color)" }}
              >
                {trip ? label : index === 0 ? "Check-in" : "Check-out"}{" "}
                <span style={{ color: "var(--red-color)" }}>*</span>
              </p>
              <p className="fw-600">
                <p className="fw-600">
                  {state[0].startDate ? (
                    format(
                      state[0][index === 0 ? "startDate" : "endDate"],
                      "EEE MMM d"
                    )
                  ) : (
                    <span style={{ color: "var(--light-grey)" }}>
                      --/--/----
                    </span>
                  )}
                </p>
              </p>
            </div>
          </div>
        ))}
      </div>

      {openCalendar && (
        <div
          className="popup-overlay"
          style={{
            top: style?.top ?? 0,
            left: style?.left ?? 0,
            right: style?.right ?? 0,
          }}
        >
          <div ref={calendarRef} className="popup-container">
            <DateRangePicker
              onChange={handleSelect}
              months={2}
              ranges={state}
              direction={calendarDirection}
              // minDate={addMonths(new Date(), 1)}
              minDate={new Date()}
              rangeColors={["#22ccb2"]}
              preventSnapRefocus={true}
              calendarFocus="forwards"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DateRangeSelector;
